const SvgWarning = () => (
	<svg width="1em" height="1em" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<ellipse cx={10} cy={9.571} rx={9} ry={8.571} fill="#100D3D" stroke="#100D3D" strokeWidth={1.5} />
		<path
			d="M11.08 12.192c.224-1.232.384-3.376.384-5.504V4H9.16v2.688c0 2.08.144 4.224.352 5.504h1.568Zm-.768 3.712c.688 0 1.28-.576 1.28-1.264 0-.704-.592-1.28-1.28-1.28-.72 0-1.312.576-1.312 1.28 0 .688.592 1.264 1.312 1.264Z"
			fill="#F6F6F6"
		/>
	</svg>
)

export default SvgWarning
